<i18n>
{
  "cl":{
    "optionNull":"Todos",
    "optionNotSelected": "Seleccione una opción",
    "isAssignedOptionTrue":"Asignados",
    "isAssignedOptionFalse":"No Asignados",
    "myProspects":"Mis prospectos",
    "analyst-list-error-message": "Ocurrió un error al cargar la lista de ejecutivos",
    "select-label-status": "Estado del prospecto",
    "select-label-prospectSubStatus": "Subestado del prospecto",
    "select-label-isAssigned": "Estado de Asignación",
    "select-label-currentAnalyst":"Ejecutivo",
    "errorGetAnalystsLists": "Ocurrió un error al cargar la lista de ejecutivos",
    "errorGetProspectStatusList": "Ocurrió un error al cargar la lista de estados de leads",
    "select-minimum-coverage":"Cobertura mínima",
    "select-maximum-coverage":"Cobertura máxima",
    "error-message-coverage":"Debe de seleccionar un rango mayor",
    "select-label-property":"Propiedad",
    "withPropriety":"Con propiedad",
    "withoutProperty":"Sin propiedad",
    "select-date-purchase":"Fecha estimada de compra",
    "select-label-date-purchase": "Seleccione fecha",
    "00-03": "Menos de 3 meses",
    "03-06": "De 3 a 6 meses",
    "06-12": "De 6 meses a 1 año",
    "12OrMore": "Más de 1 año",
    "notDefined": "No lo se",
    "purchaseDate": "Fecha estimada de compra"
  },
  "pe":{
    "optionNull":"Todos",
    "optionNotSelected": "Seleccione una opción",
    "isAssignedOptionTrue":"Asignados",
    "isAssignedOptionFalse":"No Asignados",
    "myProspects":"Mis prospectos",
    "analyst-list-error-message": "Ocurrió un error al cargar la lista de ejecutivos",
    "select-label-status": "Estado del prospecto",
    "select-label-prospectSubStatus": "Subestado del prospecto",
    "select-label-isAssigned": "Estado de Asignación",
    "select-label-currentAnalyst":"Ejecutivo",
    "errorGetAnalystsLists": "Ocurrió un error al cargar la lista de ejecutivos",
    "errorGetProspectStatusList": "Ocurrió un error al cargar la lista de estados de leads",
    "select-minimum-coverage":"Cobertura mínima",
    "select-maximum-coverage":"Cobertura máxima",
    "error-message-coverage":"Debe de seleccionar un rango mayor",
    "select-label-property":"Propiedad",
    "withPropriety":"Con propiedad",
    "withoutProperty":"Sin propiedad",
    "select-date-purchase":"Fecha estimada de compra",
    "select-label-date-purchase": "Seleccione fecha",
    "00-03": "Menos de 3 meses",
    "03-06": "De 3 a 6 meses",
    "06-12": "De 6 meses a 1 año",
    "12OrMore": "Más de 1 año",
    "notDefined": "No lo se",
    "purchaseDate": "Fecha estimada de compra"
  },
  "br":{
    "optionNull":"Todos",
    "optionNotSelected": "Seleccione uma opção",
    "isAssignedOptionTrue":"Atribuído",
    "isAssignedOptionFalse":"Não atribuído",
    "myProspects":"Meus prospects",
    "analyst-list-error-message": "Ocorreu um erro ao carregar a lista de executivos",
    "select-label-status": "Status do prospecto",
    "select-label-prospectSubStatus": "Substatus do prospecto",
    "select-label-isAssigned": "Status de la atribuição",
    "select-label-currentAnalyst":"Executivo",
    "errorGetAnalystsLists": "Ocorreu um erro ao carregar a lista de executivos",
    "errorGetProspectStatusList": "Ocorreu um erro ao carregar a lista de status do lead",
    "select-minimum-coverage":"Cobertura mínima",
    "select-maximum-coverage":"Cobertura máxima",
    "error-message-coverage":"Deve seleccionar uma gama maior",
    "select-label-property":"Propiedad",
    "withPropriety":"Com propiedade",
    "withoutProperty":"Sem propriedade",
    "select-date-purchase":"Data estimada de compra",
    "select-label-date-purchase": "Selecione a data",
    "00-03": "Menos de 3 meses",
    "03-06": "De 3 a 6 meses",
    "06-12": "De 6 meses a 1 ano",
    "12OrMore": "Mais de 1 ano",
    "notDefined": "Eu não sei",
    "purchaseDate": "Quando pretende comprar?"
  }
}
</i18n>
<template>
  <div>
    <div v-if="!isSmallScreen || showFilters" class="columns is-multiline filter-inputs">
      <div class="column is-full-until-widescreen">
        <b-field vertical custom-class="has-text-weight-normal is-small" :label="$t('select-label-status')">
          <b-select
            id="prospectStatus"
            v-model="filterInputs.prospectStatus"
            expanded
            name="prospectStatus"
            size="is-small"
            rounded
            @input="updateSubStatusList(null)">
            <option :value="null">{{ $t('optionNull') }}</option>
            <option v-for="status in prospectStatusList" :key="status._id" :value="status.name">{{ $t(`prospectStatus.${status.name}`) }}</option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-full-until-widescreen">
        <b-field vertical :label="$t('select-label-prospectSubStatus')" custom-class="has-text-weight-normal is-small">
          <b-select
            id="prospectSubStatus"
            v-model="filterInputs.prospectSubStatus"
            expanded
            name="prospectSubStatus"
            size="is-small"
            rounded>
            <option :value="null">{{ $t('optionNull') }}</option>
            <option v-for="substatus in prospectSubStatusList" :key="substatus" :value="substatus">{{ $t(`prospectSubStatus.${substatus}`) }}</option>
          </b-select>
        </b-field>
      </div>
      <div v-if="TODO" class="column is-full-until-widescreen">
        <b-field vertical :label="$t('select-label-isAssigned')" custom-class="has-text-weight-normal is-small">
          <b-select
            id="isAssigned"
            v-model="filterInputs.isAssigned"
            expanded
            name="isAssigned"
            size="is-small"
            rounded
            @input="$emit('input', filters)">
            <option :value="null">{{ $t('optionNull') }}</option>
            <option :value="true">{{ $t('isAssignedOptionTrue') }}</option>
            <option :value="false">{{ $t('isAssignedOptionFalse') }}</option>
          </b-select>
        </b-field>
      </div>
      <div v-if="analystList.length > 0 && TODO" class="column is-full-until-widescreen">
        <b-field vertical :label="$t('select-label-currentAnalyst')" custom-class="has-text-weight-normal is-small">
          <b-select
            id="currentAnalyst"
            v-model="filterInputs.currentAnalyst"
            expanded
            name="currentAnalyst"
            size="is-small"
            rounded
            @input="$emit('input', filters)">
            <option :value="null">{{ $t('optionNull') }}</option>
            <option v-for="analyst in analystList" :key="analyst._id" :value="analyst._id">{{ analyst.name }}</option>
          </b-select>
        </b-field>
      </div>
      <!--       <div class="column is-full-until-widescreen">
        <b-switch id="attendedByMe-switch" v-model="filterInputs.attendedByMe" left-label @input="$emit('input', filters)">{{ $t('myProspects') }}</b-switch>
      </div>
 -->
    </div>
    <div v-if="!isSmallScreen || showFilters" class="columns is-multiline filter-inputs">
      <div class="column">
        <div class="columns is-full-until-widescreen">
          <div class="column is-full-until-widescreen">
            <b-field
              :label="$t('select-minimum-coverage')"
              custom-class="has-text-weight-normal is-small">
              <b-select
                id="coverageMin"
                v-model="filterInputs.coverageMin"
                size="is-small"
                expanded
                rounded>
                <option :value="null">{{ $t('optionNotSelected') }}</option>
                <option v-for="coverage in coverageOptionsList" :key="coverage.label" :value="coverage.value">{{ coverage.label }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-full-until-widescreen">
            <b-field
              :label="$t('select-maximum-coverage')"
              custom-class="has-text-weight-normal is-small"
              :type="valideCoverage()"
              :message="messageCoverage()">
              <b-select
                id="coverageMax"
                v-model="filterInputs.coverageMax"
                size="is-small"
                expanded
                rounded>
                <option :value="null">{{ $t('optionNotSelected') }}</option>
                <option v-for="coverage in coverageOptionsList" :key="coverage.label" :value="coverage.value">{{ coverage.label }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-full-until-widescreen">
            <b-field
              :label="$t('select-date-purchase')"
              custom-class="has-text-weight-normal is-small">
              <b-select
                id="purchaseDate"
                v-model="filterInputs.purchaseDate"
                size="is-small"
                expanded
                rounded>
                <option :value="null">
                  {{ $t('optionNotSelected') }}
                </option>
                <option
                  v-for="purchaseDateOption in purchaseDate.options"
                  :key="purchaseDateOption.text"
                  :value="purchaseDateOption.value">
                  {{ purchaseDateOption.text }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
      <div class="column is-full-until-widescreen">
        <b-field vertical :label="$t('select-label-property')" custom-class="has-text-weight-normal is-small">
          <b-select
            id="propertyIsDefined"
            v-model="filterInputs.propertyIsDefined "
            size="is-small"
            expanded
            rounded>
            <option :value="null">{{ $t('optionNull') }}</option>
            <option :value="true">{{ $t('withPropriety') }}</option>
            <option :value="false">{{ $t('withoutProperty') }}</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div v-if="isSmallScreen" class="filter-btn">
      <b-button
        type="is-primary"
        icon-right="filter"
        @click="showFilters = !showFilters" />
    </div>
    <br>
  </div>
</template>

<script>
import { getAnalystsLists, getProspectStatusList } from '@/application/services/api-clients/prospects-leads';

export default {
  name: 'LeadsFilters',
  props: {},
  data() {
    const { _id: currentUserId } = this.$store.state.currentUser.user;
    const purchaseDateOptions = [
      '00-03',
      '03-06',
      '06-12',
      '12OrMore',
      'notDefined'].map(
      purchaseDateOption => {
        return {
          value: purchaseDateOption,
          text: this.$t(purchaseDateOption)
        };
      }
    );
    return {
      currentUserId,
      WindowWidth: window.innerWidth,
      isActive: true,
      showFilters: false,
      analystList: [],
      analystsLoading: false,
      prospectStatusList: [],
      prospectSubStatusList: [],
      prospectStatusLoading: false,
      TODO: false,
      coverageOptionsList: [
        {
          value: 0,
          label: '0%'
        },
        {
          value: 0.1,
          label: '10%'
        },
        {
          value: 0.2,
          label: '20%'
        },
        {
          value: 0.3,
          label: '30%'
        },
        {
          value: 0.4,
          label: '40%'
        },
        {
          value: 0.5,
          label: '50%'
        },
        {
          value: 0.6,
          label: '60%'
        },
        {
          value: 0.7,
          label: '70%'
        },
        {
          value: 0.8,
          label: '80%'
        },
        {
          value: 0.9,
          label: '90%'
        },
        {
          value: 1,
          label: '100%'
        }
      ],
      purchaseDate: {
        text: 'purchaseDate',
        placeholder: `${this.$t('select-label-date-purchase')}`,
        options: purchaseDateOptions
      }
    };
  },
  computed: {
    isSmallScreen() {
      return this.WindowWidth < 1400;
    },
    filterInputs: {
      get() {
        return this.$store.state.leadsModule.filterInputs;
      },
      set(filterInputsObject) {
        this.$store.dispatch('setfilterInputs', filterInputsObject);
      }
    },
    filters() {
      const returnedFilter = [];

      if (this.filterInputs.isAssigned !== null) {
        const isAssignedObj = {
          field: 'currentCommercialAnalystUserId',
          operator: '$exists',
          values: this.filterInputs.isAssigned
        };
        returnedFilter.push(isAssignedObj);
      }

      if (this.filterInputs.currentAnalyst !== null) {
        const currentAnalystObj = {
          field: 'currentCommercialAnalystUserId',
          operator: '$in',
          values: [this.filterInputs.currentAnalyst]
        };
        returnedFilter.push(currentAnalystObj);
      }

      if (this.filterInputs.attendedByMe) {
        const isAssignedObj = {
          field: 'currentCommercialAnalystUserId',
          operator: '$in',
          values: [this.currentUserId]
        };
        returnedFilter.push(isAssignedObj);
      }

      if (this.filterInputs.prospectStatus) {
        const statusFilter = {
          field: 'status',
          operator: '$in',
          values: [this.filterInputs.prospectStatus]
        };
        returnedFilter.push(statusFilter);
      }
      if (this.filterInputs.prospectSubStatus) {
        const statusFilter = {
          field: 'subStatus',
          operator: '$in',
          values: [this.filterInputs.prospectSubStatus]
        };
        returnedFilter.push(statusFilter);
      }

      if (this.filterInputs.coverageMin !== null && this.filterInputs.coverageMin !== undefined) {
        const coverageMin = {
          field: 'simulations.financingRatio',
          operator: '$gte',
          values: this.filterInputs.coverageMin
        };
        returnedFilter.push(coverageMin);
      }

      if (this.filterInputs.coverageMax !== null && this.filterInputs.coverageMax !== undefined) {
        const coverageMax = {
          field: 'simulations.financingRatio',
          operator: '$lte',
          values: this.filterInputs.coverageMax
        };
        returnedFilter.push(coverageMax);
      }

      if (this.filterInputs.propertyIsDefined !== null && this.filterInputs.propertyIsDefined !== undefined) {
        const propertyIsDefined = {
          field: 'simulations.propertyIsDefined',
          operator: '$eq',
          values: this.filterInputs.propertyIsDefined
        };
        returnedFilter.push(propertyIsDefined);
      }

      if (this.filterInputs.purchaseDate !== null) {
        const dateEstimatedPurchase = {
          field: 'simulations.purchaseDate',
          operator: '$eq',
          values: this.filterInputs.purchaseDate
        };
        returnedFilter.push(dateEstimatedPurchase);
      }

      return returnedFilter;
    }
  },
  watch: {
    filterInputs: {
      deep: true,
      handler(val) {
        this.filterInputs = val;
        this.$emit('input', this.filters);
      }
    }
  },
  mounted() {
    this.getAnalystsLists();
    this.getProspectStatusList();
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    updateSubStatusList(nullOption) {
      if (this.filterInputs.prospectStatus === null) {
        this.filterInputs.prospectSubStatus = null;
        this.prospectSubStatusList = [];
        return;
      }
      const { subStatus } = this.prospectStatusList.find(({ name }) => name === this.filterInputs.prospectStatus);
      this.prospectSubStatusList = subStatus;
      /** Cuando se cambia el status, cualquier substatus que tengamos
       * en el store, haciendo referencia al status anterior, no existe o no es lo mismo
       * por lo tanto, setear null setea el subStatus a "todos" que es el subStatus null
       */
      if (nullOption === null) { this.filterInputs.prospectSubStatus = nullOption; }
    },
    handleResize() {
      this.WindowWidth = window.innerWidth;
    },
    async getAnalystsLists() {
      this.analystsLoading = true;
      try {
        this.analystList = await getAnalystsLists();
      } catch (_error) {
        this.analystList = [];
        this.$buefy.toast.open({
          position: 'is-top-right',
          /** @todo : make translation work here :) */
          message: this.$t('errorGetAnalystsLists'),
          // message: 'Ocorreu um erro ao carregar a lista de executivos',
          type: 'is-danger',
          duration: 5000
        });
      }
      this.analystsLoading = false;
    },
    async getProspectStatusList() {
      this.prospectStatusLoading = true;
      try {
        this.prospectStatusList = await getProspectStatusList();
        this.updateSubStatusList();
      } catch (_error) {
        this.prospectStatusList = [];
        this.$buefy.toast.open({
          position: 'is-top-right',
          /** @todo : make translation work here :) */
          message: this.$t('errorGetProspectStatusList'),
          // message: 'Ocorreu um erro ao carregar a lista de status do lead',
          type: 'is-danger',
          duration: 5000
        });
      }
    },
    coverageIsValid() {
      const coverageMax = this.filterInputs.coverageMax == null ? 1 : this.filterInputs.coverageMax;
      const coverageMin = this.filterInputs.coverageMin == null ? 0 : this.filterInputs.coverageMin;
      return coverageMax >= coverageMin;
    },
    valideCoverage() {
      if (this.coverageIsValid()) {
        return null;
      }
      return 'is-danger';
    },
    messageCoverage() {
      if (this.coverageIsValid()) {
        return null;
      }
      return this.$t('error-message-coverage');
    }
  }
};
</script>
<style>
.filter-btn {
  position: absolute;
  top: 1.5rem;
  right: 2rem;
}
</style>
